export const PAGE_TITLE = "My Profile";
export const PAGE_SUBTITLE = "Update your practitioner information";

export const GENDER_OPTIONS = [
  { label: "Female", value: "Female" },
  { label: "Male", value: "Male" },
  { label: "Non-binary", value: "Non-binary" },
  { label: "Prefer not to say", value: "Prefer not to say" },
];

// Compliance / document uploads.
// key = field on the profile; multi = many files (Postgres ARRAY); accept = file types.
const DOC = "application/pdf,image/*";
export const COMPLIANCE_DOCS = [
  { key: "scopeOfPractice", label: "Signed Scope of Practice & Code of Ethics", multi: false, accept: DOC },
  { key: "hipaaAcknowledgement", label: "HIPAA Acknowledgement / Policies", multi: true, accept: DOC },
  { key: "insuranceCertificates", label: "Professional Indemnity Insurance", multi: true, accept: DOC },
  { key: "backgroundCheck", label: "Criminal Background Check", multi: false, accept: DOC },
  { key: "hipaaCertificate", label: "HIPAA Compliance Certificate", multi: false, accept: DOC },
  { key: "businessAssociateAgreementFile", label: "Business Associate Agreement", multi: false, accept: DOC },
  { key: "clientAgreementAckFile", label: "Client Participation Agreement", multi: false, accept: DOC },
  { key: "businessTaxReceipt", label: "Business Tax Receipt", multi: false, accept: DOC },
  { key: "leaseOrUtilityBill", label: "Address Verification (Lease / Utility Bill)", multi: true, accept: DOC },
  { key: "roomPrivacyPhotos", label: "Room Privacy Photos", multi: true, accept: "image/*" },
  { key: "officeVerification", label: "Office Verification Documents", multi: true, accept: DOC },
];

// All document field keys (single + multi) — used to seed form state + save payload.
export const SINGLE_DOC_FIELDS = COMPLIANCE_DOCS.filter((d) => !d.multi).map((d) => d.key);
export const MULTI_DOC_FIELDS = COMPLIANCE_DOCS.filter((d) => d.multi).map((d) => d.key);

// Fields stored as arrays in the DB but edited as one-entry-per-line text.
export const MULTILINE_ARRAY_FIELDS = ["experience", "education", "certifications"];

// Simple URL check for social/web fields (empty allowed).
export const isValidUrl = (v) => {
  if (!v) return true;
  try {
    const u = new URL(v.startsWith("http") ? v : `https://${v}`);
    return !!u.hostname && u.hostname.includes(".");
  } catch {
    return false;
  }
};
